const data = {
    custom_hybrid: {
        sampleImage: "/images/displays/custom_hybrid/prod_cust_modular.jpg",
        sampleAlt: "custom modular",
        pdf: "",
        index: 0,
        showButton: true,
        images: [
            "/images/displays/custom_hybrid/avantor-mdm-west.jpg",
            "/images/displays/custom_hybrid/avantor-bio.jpg",
            "/images/displays/custom_hybrid/aerzen-weftec.jpg",
            "/images/displays/custom_hybrid/aerzen-weftec2.jpg",
            "/images/displays/custom_hybrid/aerzen-weftec3.jpg",
            "/images/displays/custom_hybrid/aerzen-turbo.jpg",
            "/images/displays/custom_hybrid/aerzen-turbo2.jpg",
            "/images/displays/custom_hybrid/avantor2.jpg",
            "/images/displays/custom_hybrid/avantor1.jpg",
            "/images/displays/custom_hybrid/veeva-cloud.jpg",
            "/images/displays/custom_hybrid/wall-of-fame.jpg",
            "/images/displays/custom_hybrid/aerzen_30x30a.jpg",
            "/images/displays/custom_hybrid/aerzen_30x30b.jpg",
            "/images/displays/custom_hybrid/custom_veeva20x20a.jpg",
            "/images/displays/custom_hybrid/custom_veeva20x20b.jpg",
            "/images/displays/custom_hybrid/world-travel1.jpg",
            "/images/displays/custom_hybrid/world-travel2.jpg",
            "/images/displays/custom_hybrid/Morphotek-10x10.jpg",
            "/images/displays/custom_hybrid/vwr20.jpg",
            "/images/displays/custom_hybrid/Ward_All_VersionsB-1.jpg",
            "/images/displays/custom_hybrid/Ward_All_VersionsB-2.jpg",
            "/images/displays/custom_hybrid/Ward_All_VersionsB-6.jpg",
            "/images/displays/custom_hybrid/hybrid_vwr_10.jpg",
            "/images/displays/custom_hybrid/hybrid_vwr_10b.jpg",
            "/images/displays/custom_hybrid/hybrid_vwr_20.jpg",
            "/images/displays/custom_hybrid/portable_aerzen_10x20.jpg",
            "/images/displays/custom_hybrid/custom_veeva10.jpg",
            "/images/displays/custom_hybrid/custom_veeva20.jpg",
            "/images/displays/custom_hybrid/portable_aerzen10.jpg",
            "/images/displays/custom_hybrid/hybrid_aerzen20.jpg",
            "/images/displays/custom_hybrid/hybrid_aerzen30.jpg",
            "/images/displays/custom_hybrid/hybrid_morphotek.jpg"
        ],
        captions: [
            "20x20 Custom Build",
            "20x40 Custom Build",
            "30x30 Custom Build",
            "30x30 Custom Build",
            "30x30 Custom Build",
            "20x20 Custom Build",
            "20x20 Custom Build",
            "Custom Build",
            "Custom Build",
            "Custom Build",
            "Custom Build",
            "30x30 Custom Build",
            "30x30 Custom Build",
            "20x20 Custom Build",
            "20x20 Custom Build",
            "20x30 Custom Build",
            "20x30 Custom Build",
            "10x10 Modular",
            "10x20 Custom Build",
            "20x20 Custom Build",
            "20x20 Custom Build",
            "10x20 Custom Build",
            "10x10 Portable",
            "10x10 Portable",
            "10x20 Portable",
            "10x20 Portable",
            "10x10 Custom Build",
            "10x20 Custom Build",
            "10x10 Portable",
            "10x20 Custom Build",
            "20x30 Custom Build",
            "Custom Modular Display"
        ]
    },
    expanding_frame:{
        sampleImage: "/images/displays/expanding_frame/prod_tabletop.jpg",
        sampleAlt: "expanding frame",
        pdf: "",
        index: 0,
        showButton: true,
        images: [
            "/images/displays/expanding_frame/amerigas-diamond-2023.jpg",
            "/images/displays/expanding_frame/amerigas-straight-2023.jpg",
            "/images/displays/expanding_frame/airtable1.jpg",
            "/images/displays/expanding_frame/airtable2.jpg",
            "/images/displays/expanding_frame/snap_veeva1.jpg",
            "/images/displays/expanding_frame/snap_amerigas_table.jpg",
            "/images/displays/expanding_frame/snap_valor.jpg",
            "/images/displays/expanding_frame/snap_fogmaker.jpg",
            "/images/displays/expanding_frame/snap_ussc_rebranded1.jpg",
            "/images/displays/expanding_frame/snap_ussc_rebranded2.jpg",
            "/images/displays/expanding_frame/vburst_gss2.jpg",
            "/images/displays/expanding_frame/vburst_gss.jpg",
            "/images/displays/expanding_frame/snap_veeva2.jpg",
            "/images/displays/expanding_frame/snap_vwr.jpg",
            "/images/displays/expanding_frame/snap_aquatic_facility.jpg",
            "/images/displays/expanding_frame/snap_oneill.jpg",
            "/images/displays/expanding_frame/vburst_wards.jpg",
            "/images/displays/expanding_frame/vburst_wards2.jpg",
            "/images/displays/expanding_frame/vburst_aerzen.jpg",
            "/images/displays/expanding_frame/vburst_iiw.jpg",
            "/images/displays/expanding_frame/vburst_vwr.jpg"
        ],
        captions: [
            "10x10 Expanding Frame booth",
            "8' Expanding Frame with end caps",
            "8' Expanding Frame with end caps",
            "8' Expanding Frame with end caps",
            "Expanding Frame Tabletop",
            "Expanding Frame Tabletop",
            "Expanding Frame Tabletop",
            "Expanding Frame Tabletop",
            "Expanding Frame Tabletop",
            "Expanding Frame Tabletop",
            "8' Expanding Frame",
            "8' Expanding Frame",
            "Expanding Frame Tabletop",
            "Expanding Frame Tabletop",
            "Expanding Frame Tabletop",
            "Expanding Frame 10x10 Booth",
            "Expanding Frame 10x10 Booth",
            "Expanding Frame Display",
            "Expanding Frame Display",
            "Expanding Frame Display",
            "Expanding Frame Display",
            "Expanding Frame Display"
        ]
    },
    navigator:{
        sampleImage: "/images/displays/pillowcase/prod_navigator.jpg",
        sampleAlt: "Pillowcase Displays",
        pdf: "",
        index: 0,
        showButton: true,
        images: [
            "/images/displays/pillowcase/curved_navigator_10_fusion.jpg",
            "/images/displays/pillowcase/curved_navigator_10_vwr.jpg",
            "/images/displays/pillowcase/navigator_20_avantor.jpg",
            "/images/displays/pillowcase/straight_navigator_20_vwr.jpg",
            "/images/displays/pillowcase/navigator10_curved_aerzen.jpg",
            "/images/displays/pillowcase/navigator10_curved_bdh.jpg",
            "/images/displays/pillowcase/navigator10_curved_amresco.jpg",
            "/images/displays/pillowcase/navigator10_curved_vwr.jpg",
            "/images/displays/pillowcase/navigator10_curved_vwr2.jpg",
            "/images/displays/pillowcase/navigator10_straight_boreal1.jpg",
            "/images/displays/pillowcase/navigator10_straight_boreal2.jpg"
        ],
        captions: [
            "10' curved Pillowcase",
            "10' curved Pillowcase",
            "20' curved Pillowcase",
            "20' straight Pillowcase",
            "8' curved Pillowcase",
            "10' curved Pillowcase",
            "10' curved Pillowcase",
            "10' curved Pillowcase",
            "10' curved Pillowcase",
            "10' straight Pillowcase",
            "10' straight Pillowcase"
        ]
    },
    rentals:{
        sampleImage: "/images/displays/rentals/prod_rentals.jpg",
        sampleAlt: "Rentals",
        pdf: "",
        index: 0,
        showButton: true,
        images: [
            "/images/displays/rentals/Nusil_20x20.jpg",
            "/images/displays/rentals/GK-1015a.jpg",
            "/images/displays/rentals/re-1008-1.jpg",
            "/images/displays/rentals/RE-1086a.jpg",
            "/images/displays/rentals/RE-2097a.jpg",
            "/images/displays/rentals/RE-2111a.jpg",
            "/images/displays/rentals/RE-2137a.jpg",
            "/images/displays/rentals/re-2146a.jpg",
            "/images/displays/rentals/re2030-1.jpg",
            "/images/displays/rentals/re3005-clearwire1.jpg",
            "/images/displays/rentals/VK-1334a.jpg",
            "/images/displays/rentals/VK-1963a.jpg",
            "/images/displays/rentals/VK-2987a.jpg",
            "/images/displays/rentals/telstar1.jpg",
            "/images/displays/rentals/telstar2.jpg",
            "/images/displays/rentals/vwr1.jpg",
            "/images/displays/rentals/vwr2.jpg",
            "/images/displays/rentals/sai360-2.jpg",
            "/images/displays/rentals/nusil.jpg",
            "/images/displays/rentals/nusil1.jpg",
            "/images/displays/rentals/veeva.jpg",
            "/images/displays/rentals/strategic_20.jpg",
            "/images/displays/rentals/TradeOnly-20x30_A_0100.jpg",
            "/images/displays/rentals/Core_20x20_1B8-1.jpg",
            "/images/displays/rentals/Core_20x20_1B8-3.jpg",
            "/images/displays/rentals/Core_20x20_1B8-1.jpg",
            "/images/displays/rentals/Focus.jpg",
            "/images/displays/rentals/HRS_Tower.jpg",
            "/images/displays/rentals/Merit_Geno_20x20_FinalArt2nd-1.jpg",
            "/images/displays/rentals/Merit_Geno_20x20_FinalArt2nd-4.jpg",
            "/images/displays/rentals/Micasa_10x10.jpg",
            "/images/displays/rentals/Micasa_10x20.jpg",
            "/images/displays/rentals/Micasa_20x20.jpg",
            "/images/displays/rentals/NextDocs_2.jpg",
            "/images/displays/rentals/NextDocs_4.jpg",
            "/images/displays/rentals/Premier_Tradeshow_3Booths-1.jpg",
            "/images/displays/rentals/Premier_Tradeshow_3Booths-3.jpg",
            "/images/displays/rentals/Premier_Tradeshow_3Booths-4.jpg",
            "/images/displays/rentals/Premier_Tradeshow_3Booths-5.jpg",
            "/images/displays/rentals/Premier-1.jpg",
            "/images/displays/rentals/Premier-4.jpg",
            "/images/displays/rentals/Premier-Research_10x10_1A-1B-2-2.jpg",
            "/images/displays/rentals/Premier-Research_10x10_1A-1B-2-5.jpg",
            "/images/displays/rentals/Premier-Research_10x10_1A-1B-2-8.jpg",
            "/images/displays/rentals/Premier-Research_20x20_revised-2.jpg",
            "/images/displays/rentals/Premier-Research_20x20_revised-4.jpg",
            "/images/displays/rentals/Premier-Research_20x20_revised-7.jpg",
            "/images/displays/rentals/Core_20x20_1B8-1.jpg"
        ],
        captions: [
            "Nusil 20x20 rental",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available",
            "One of many rentals available"
        ]
    },
    bannerstands:{
        sampleImage: "/images/displays/bannerstands/prod_bannerstands.jpg",
        sampleAlt: "Bannerstands and tablecloths",
        pdf: "",
        index: 0,
        showButton: true,
        images: [
            "/images/displays/bannerstands/gtm-banners.jpg",
            "/images/displays/bannerstands/bannerstand-avantor1-2023.jpg",
            "/images/displays/bannerstands/bannerstand-veeva-2023.jpg",
            "/images/displays/bannerstands/bannerstand-aerzen.jpg",
            "/images/displays/bannerstands/tablethrow-amerigas-2024.jpg",
            "/images/displays/bannerstands/tablethrow-vooner.jpg",
            "/images/displays/bannerstands/tablethrow-aerzen-2023.jpg",
            "/images/displays/bannerstands/tablethrow-amerigas-2023.jpg",
            "/images/displays/bannerstands/bannerstand-gtm-2023.jpg",
            "/images/displays/bannerstands/bannerstand-avantor-2023.jpg",


        ],
        captions: [
            "3 Bannerstands",
            "Bannerstands",
            "Bannerstands",
            "Bannerstands",
            "Custom Printed Tablecloth",
            "Custom Printed Tablecloth",
            "Custom Printed Tablecloth",
            "Custom Printed Tablecloth",
            "Bannerstand",
            "Bannerstand",
        ]
    },
    seg:{
        sampleImage: "/images/displays/seg/prod_seg_extrusions.jpg",
        sampleAlt: "SEG Extrusions",
        pdf: "",
        index: 0,
        showButton: true,
        images: [
            "/images/displays/seg/seg-wall-10-nusil.jpg",
            "/images/displays/seg/seg-wall-10-vwr.jpg",
            "/images/displays/seg/seg-wall-20-jtbaker.jpg",
            "/images/displays/seg/seg-wall-20-vwr.jpg",
            "/images/displays/seg/seg-wall-20-vwr2.jpg",
            "/images/displays/seg/seg-wall-10.jpg",
            "/images/displays/seg/seg-wall-20.jpg",
            "/images/displays/seg/seg-wall-30.jpg",
            "/images/displays/seg/seg_aerzen1.jpg",
            "/images/displays/seg/seg_aerzen2.jpg",
            "/images/displays/seg/seg_gss.jpg",
            "/images/displays/seg/seg_extrusions.jpg"
        ],
        captions: [
            "SEG Freestanding 10' Wall",
            "SEG Freestanding 10' Wall",
            "SEG Freestanding 20' Wall",
            "SEG Freestanding 20' Wall",
            "SEG Freestanding 20' Wall",
            "SEG Freestanding 10' Wall",
            "SEG Freestanding 20' Wall",
            "SEG Freestanding 30' Walls",
            "SEG Extrusion Systems",
            "SEG Extrusion Systems",
            "SEG Extrusion Systems",
            "SEG Extrusion Systems"
        ]
    },
    overhead:{
        sampleImage: "/images/displays/overhead/prod_overhead.jpg",
        sampleAlt: "Overhead",
        pdf: "",
        index: 0,
        showButton: true,
        images: [
            "/images/displays/overhead/overhead-aerzen1.jpg",
            "/images/displays/overhead/overhead-aerzen2.jpg",
            "/images/displays/overhead/overhead-veeva.jpg",
            "/images/displays/overhead/hanging_sign_crossroads.jpg",
            "/images/displays/overhead/hanging_sign_gss.jpg",
            "/images/displays/overhead/overhead-wards.jpg"
        ],
        captions: [
            "Overhead",
            "Overhead",
            "Overhead",
            "Overhead",
            "Overhead",
            "Overhead"
        ]
    },
    backlits:{
        sampleImage: "/images/displays/backlits/prod_backlits.jpg",
        sampleAlt: "Backlits",
        pdf: "",
        index: 0,
        showButton: true,
        images: [
            "/images/displays/backlits/suki-20-with-monitor2.jpg",
            "/images/displays/backlits/ss-SAI-lightbox.jpg",
            "/images/displays/backlits/suki-5-lightbox.jpg",
            "/images/displays/backlits/suki-20-with-monitor.jpg",
            "/images/displays/backlits/aerzen-hydrogen.jpg",
            "/images/displays/backlits/aerzen-rental-general.jpg",
            "/images/displays/backlits/aerzen-pet-food.jpg",
            "/images/displays/backlits/aerzen-sts-1.jpg",
            "/images/displays/backlits/aerzen-sts-2.jpg",
            "/images/displays/backlits/avantor-backlit.jpg",
            "/images/displays/backlits/belynKey.jpg",
            "/images/displays/backlits/10x20-Voomer-Render.jpg",
            "/images/displays/rentals/sai360.jpg",
            "/images/displays/backlits/pliko-avantor1.jpg",
            "/images/displays/backlits/pliko-avantor2.jpg",
            "/images/displays/backlits/backlit-valor.jpg",
        ],
        captions: [
            "20x8 full-height backlit with monitor",
            "10x8 full-height backlit",
            "10x5 full-height backlit",
            "20x8 full-height backlit with monitor",
            "10x8 full-height backlit",
            "10x8 full-height backlit",
            "10x8 full-height backlit",
            "twin 10x8 backlit back wall",
            "twin 10x8 backlit back wall",
            "10x8 full-height backlit",
            "10x8 full-height with 5x6 reduced-height wings",
            "10x8 full-height with 5x8 full-height wings",
            "Two 10x8 full-height and two 5x8 full height, plus podium",
            "Tool-free double-sided SEG backlit",
            "Tool-free double-sided SEG backlit",
            "Backlit"
        ]
    }
};

export default data;




// WEBPACK FOOTER //
// ./src/data/displays.js